import { render, staticRenderFns } from "./subproperty-dashboard.vue?vue&type=template&id=5552bb7b&scoped=true&"
import script from "./subproperty-dashboard.vue?vue&type=script&lang=js&"
export * from "./subproperty-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./subproperty-dashboard.vue?vue&type=style&index=0&id=5552bb7b&scoped=true&lang=css&"
import style1 from "./subproperty-dashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552bb7b",
  null
  
)

export default component.exports